/*
 |--------------------------------------------------------------------------
 | Meer informatie module
 |--------------------------------------------------------------------------
 */

/* ========================================================================== *\
 IMPORTS
 \* ========================================================================== */

//no imports needed

/* == END IMPORTS =========================================================== */

/* ========================================================================== *\
 CONSTANTS
 \* ========================================================================== */

const
  /**
   * The module name
   * @type {String}
   */
  moduleName = 'expansion-panel',
  /**
   * Lookup table with class names
   * @type {Object}
   */
  classNames = {
    panel: `js-${moduleName}`,
    trigger: `${moduleName}__trigger`,
    header: `${moduleName}__header`,
    content: `${moduleName}__content`,
    isExpanded: `${moduleName}--expanded`,
    accordion: 'accordion'
  },
/**
   * Lookup table for selectors
   * @type {Object}
   */
  selectors = {
    panel: `.${classNames.panel}`,
    trigger: `.${classNames.trigger}`,
    header: `.${classNames.header}`,
    content: `.${classNames.content}`,
    accordion: `.${classNames.accordion}`
  };

/* == END CONSTANTS ========================================================= */

/* ========================================================================== *\
 SETUP EXPANSION PANEL
 \* ========================================================================== */

class ExpansionPanel {
  constructor(element) {
    this.element = element;
    this.panels = null
  }

  init() {
    this.triggers = this.element.querySelectorAll(selectors.trigger)
    this.content = this.element.querySelector(selectors.content);
    this.header = this.element.querySelector(selectors.header);

    this.element.addEventListener('expand', this.expand.bind(this));
    this.element.addEventListener('collapse', this.collapse.bind(this));
    this.element.addEventListener('toggle', this.toggle.bind(this));

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        this.toggle();
        event.stopPropagation();
      });
    })

    this.header.addEventListener('click', this.toggle.bind(this));

    // Set expanded class
    if (this.isExpanded()) {
      this.element.classList.add(classNames.isExpanded);
    }

    // Add accordion behavior
    if (this.isChildOfAccordion()) {
      this.initAccordion();
    }
  }

  initAccordion() {
    this.panels = this.element.parentNode.querySelectorAll(selectors.panel);
    const index = Array.prototype.indexOf.call(this.panels, this.element)

    // Expand first panel and collapse following siblings
    if ((index === 0 && !this.isExpanded()) || (index > 0 && this.isExpanded())) {
      this.toggle();
    }
  }

  toggle() {
    if (this.isExpanded()) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  expand() {
    this.element.classList.add(classNames.isExpanded);
    this.content.removeAttribute('hidden');
    this.triggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'true')
    })
  }

  collapse() {
    this.element.classList.remove(classNames.isExpanded);
    this.content.setAttribute('hidden', true);
    this.triggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false')
    })
  }

  isExpanded() {
    return !this.content.hasAttribute('hidden');
  }

  isChildOfAccordion() {
    return !!this.element.closest(selectors.accordion);
  }
}
/* == END SETUP EXPANSION PANEL ===================================================== */

/* ========================================================================== *\
 EVENT HANDLING
 \* ========================================================================== */

// No event handling needed

/* == END EVENT HANDLING ==================================================== */

/* ========================================================================== *\
 INITIALIZATION
 \* ========================================================================== */

document.querySelectorAll(selectors.panel).forEach((element) => {
  const expansionPanel = new ExpansionPanel(element);

  expansionPanel.init();
})

/* == END INITIALIZATION ==================================================== */

/* ========================================================================== *\
 EXPORTS
 \* ========================================================================== */

// No exports, just default behaviour

/* == END EXPORTS ====================================================== */

